import { useMutation } from '@tanstack/react-query';
import { authHeader, handleResponse } from '../queryClient';
import { useActiveCompany } from '../utils/useCompany';

/* Start self-study simulation */
export const useStartSimulation = ({
  exerciseId,
  assignmentGroupId,
  onError,
  onSuccess,
}: {
  exerciseId?: string | null;
  assignmentGroupId?: string | null;
  onError: (error: Response) => void;
  onSuccess: (data: { sessionId: string }) => void;
}) => {
  const company = useActiveCompany();

  const {
    mutate: startSimulation,
    isLoading: simulationStarting,
    error: startSimulationError,
  } = useMutation<{ sessionId: string }, Response>({
    onError(error) {
      onError(error);
    },
    onSuccess(data) {
      onSuccess(data);
    },
    async mutationFn() {
      return fetch(`/api/session/start-assignment`, {
        body: JSON.stringify({
          assignmentGroupId: assignmentGroupId,
          assignmentId: exerciseId,
          companyId: company!.companyId,
        }),
        headers: { ...(await authHeader()), 'Content-Type': 'application/json' },
        method: 'POST',
      }).then(handleResponse);
    },
    mutationKey: ['startSimulation'],
  });

  return { startSimulation, simulationStarting, startSimulationError };
};

export const useStartClassroomSimulation = ({
  classroomId,
  onError,
  onSuccess,
}: {
  classroomId?: string;
  onError: (error: Response) => void;
  onSuccess: (data: { sessionId: string }) => void;
}) => {
  const company = useActiveCompany();

  const {
    mutate: startSimulation,
    isLoading: simulationStarting,
    error: startSimulationError,
  } = useMutation<{ sessionId: string }, Response>({
    onError(error) {
      onError(error);
    },
    onSuccess(data) {
      onSuccess(data);
    },
    async mutationFn() {
      return fetch(`/api/session/start-classroom`, {
        body: JSON.stringify({
          classroomId,
          companyId: company!.companyId,
        }),
        headers: { ...(await authHeader()), 'Content-Type': 'application/json' },
        method: 'POST',
      }).then(handleResponse);
    },
    mutationKey: ['startClassroomSimulation'],
  });

  return { startSimulation, simulationStarting, startSimulationError };
};
